import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ITranslatedTableService } from 'app/admin/config/TranslatedTableConfig';

@Injectable({
  providedIn: 'root'
})
export class PartnerPricingToolFeatureTranslationService implements ITranslatedTableService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/partnerpricingtoolfeaturetranslations`;

  constructor(private http: HttpClient) { }

  getMany(languageId: number, includeMissing: boolean): Observable<Boo.Objects.SEOPresence.PartnerPricingToolFeature[]> {
    const params = new HttpParams()
      .set('languageId', languageId)
      .set('includeMissing', includeMissing);

    return this.http.get<Boo.Objects.SEOPresence.PartnerPricingToolFeature[]>(`${this.baseUrl}/GetMany`, { params: params });
  }

  saveMany(translations: Boo.Objects.SEOPresence.PartnerPricingToolFeature[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/SaveMany`, translations);
  }
}
